import { ReactNode } from 'react'

interface DashboardLayoutProps {
  children: ReactNode
}

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  return (
    <div className="page-container section-padding animate-fade-in">
      {children}
    </div>
  )
}

export default DashboardLayout
